import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/group",
    name: "Group",
    component: function() {
      return import("../views/GroupDetails.vue");
    },
  },
  {
    path: "/group/settings",
    name: "Settings",
    component: function() {
      return import("../views/GroupSettings.vue");
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
